import { Flex, Text } from '@chakra-ui/react';
import { convertNumberToLocaleString } from '@shared/utils';
import { useTranslation } from 'react-i18next';

interface IProductTotalProps {
  total: number;
}

export const ProductTotal = ({ total }: IProductTotalProps) => {
  const { t } = useTranslation('common');

  return (
    <Flex justify="space-between" align="center">
      <Text fontSize="lg" color="brand.500" fontWeight="semibold">
        {t('monthlyTotal')}
      </Text>
      <Text fontSize="2xl" color="brand.500" fontWeight="semibold">
        {convertNumberToLocaleString(total)}
      </Text>
    </Flex>
  );
};
